// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___U3ZZ","rootNoMargin":"styles_rootNoMargin__3Ak3P"};